import React from "react";
import "./StudentNotification.css";

export const StudentNotificationSkeleton = ({ count = 5 }) => {
  return (
    <div className="notification-list">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="notification-card d-flex align-items-start justify-content-between mb-2 p-3"
        >
          <div className="d-flex align-items-start w-100">
            <div className="skeleton-dot me-2"></div>

            <div className="notification-content w-100">
              <div className="skeleton-title mb-2"></div>
              <div className="skeleton-desc mb-1"></div>
              <div className="skeleton-time"></div>
            </div>
          </div>

          <div className="skeleton-btn"></div>
        </div>
      ))}
    </div>
  );
};